module.exports = __webpack_public_path__ + "img/3.6c8ed727.jpg";